<span
  mat-button
  mat-dialog-close
  class="unlock-close-btn"
  aria-label="Close dialog"
>
  <i id="closeOverlay" class="far fa-times-circle"></i>
</span>

<h1 mat-dialog-title class="unlock-title">Delivery OTP</h1>
<hr class="divider">

<div
  mat-dialog-content
  class="unlock-content"
  role="dialog"
  aria-modal="true"
  aria-labelledby="unlock-title"
>
  <div class="unlock-header">
    <p class="unlock-subtitle">Share this code with customer</p>
    
    <div class="otp-display">
      <div class="otp-code">{{ delivery?.deliveryCode }}</div>
      <button 
        class="copy-btn"
        (click)="copyOTP()"
        mat-icon-button
        aria-label="Copy OTP"
      >
        <i class="fas fa-copy"></i>
      </button>
    </div>
    
    <div class="otp-feedback" #feedback *ngIf="showFeedback">
      Copied to clipboard!
    </div>
  </div>
</div>

<div mat-dialog-actions class="unlock-actions">
  <button mat-button mat-dialog-close class="btn-secondary">Close</button>
</div>
